/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import {
  Asset,
  AssetsApi,
  Constants,
  Ducks,
  FileFormatToFileTypeMap,
  ParentalControlSettings,
  SearchUtils,
} from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';

function* getAsset(ksql: string): SagaIterator<Asset | undefined> {
  if (ksql === '') {
    return undefined;
  }

  const filesFormat: FileFormatToFileTypeMap = yield select(Ducks.Dms.Selectors.getFilesFormat);
  const parentalControlSettings: ParentalControlSettings = yield select(Ducks.Dms.Selectors.getParentalControl);

  const result: Asset[] = yield Ducks.Pagination.callPaginatedApi(
    ksql,
    0,
    Constants.DEFAULT_API_PAGE_SIZE,
    Constants.DEFAULT_API_PAGE_SIZE,
    AssetsApi.assetSearch,
    ksql,
    filesFormat,
    parentalControlSettings
  );

  yield call(Ducks.Pagination.clearPaginatedApi, ksql);

  return result[0];
}

function* getProgram(id: number): SagaIterator<Asset | undefined> {
  const ksql = SearchUtils.createEpgsFilter([id]);

  return yield call(getAsset, ksql);
}

function* getProgramFromExternalId(id: string): SagaIterator<Asset | undefined> {
  const ksql = SearchUtils.createEpgFromExternalIdFilter(id);

  return yield call(getAsset, ksql);
}

function* getMedia(id: number): SagaIterator<Asset | undefined> {
  const ksql = SearchUtils.createMediasFilter([id]);

  return yield call(getAsset, ksql);
}

export default {
  getMedia,
  getProgram,
  getProgramFromExternalId,
};
